export default "__VITE_ASSET__C7p80cD3__"